import { LiveVideoFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreateLiveVideoFlightArgs,
    UpdateLiveVideoFlightArgs,
} from "@nova/serializer/src/client/validators/flights/liveVideo"
import { deleteEntitySocket, updateEntitySocket } from "features/entity-caching/project/slice"

const {
    update: updateVideoFlight,
    delete: deleteVideoFlight,
    updateAction,
    deleteAction,
} = generateGenericCases<
    LiveVideoFlight, // entity type
    CreateLiveVideoFlightArgs, // create args to send to server
    ["createdBy", "name", "saveRecording", "isMMA"], // create args required by action
    UpdateLiveVideoFlightArgs,
    void,
    { workspaceId?: string } // update args
>("LiveVideoFlight")

export const addLiveVideoFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(updateAction, (store, { payload: { id, updates } }, socket) => {
            updateVideoFlight(socket, id, updates, {})
            store.dispatch(updateEntitySocket({ updates, path: ["liveVideoFlights", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            deleteVideoFlight(socket, id, {})
            store.dispatch(deleteEntitySocket({ path: ["liveVideoFlights", { id }] }))
        })
export { updateAction as updateLiveVideoFlight, deleteAction as deleteLiveVideoFlight }
